import { useBusiness } from '../components/BusinessContext'
import { useShopStudio } from '../contexts/ShopStudioContext'
import { setupSteps, SetupStep, SetupStepId } from '../data/hubSetup'

/**
 * One reading of where the merchant is on the getting-started path, shared by
 * the Dashboard guide, the header progress pill and the module intros so they
 * can never disagree. Publishing is read from the shop itself rather than
 * tracked separately, so it is only ever "done" when the shop really is live.
 * Must be used inside ShopStudioProvider.
 */
export function useSetupProgress() {
  const { setupDone, setupHidden } = useBusiness()
  const { config } = useShopStudio()

  const isDone = (id: SetupStepId) =>
    id === 'publish' ? config.published : setupDone.includes(id)

  const done = setupSteps.filter((s) => isDone(s.id))
  const next: SetupStep | undefined = setupSteps.find((s) => !isDone(s.id))

  return {
    steps: setupSteps,
    isDone,
    doneCount: done.length,
    total: setupSteps.length,
    next,
    complete: !next,
    hidden: setupHidden,
  }
}
